/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var OnedriveIcon = createIcon("OnedriveIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '#171717';
  return /*#__PURE__*/React.createElement("svg", {
    "data-replace-color": _color,
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M22.465 16.746a4.468 4.468 0 00-3.632-6.578A6.875 6.875 0 006.429 8.096a5.498 5.498 0 00-4.441 8.642h-.001a5.493 5.493 0 004.512 2.357h12.032a4.467 4.467 0 003.934-2.349Z",
    stroke: _color,
    strokeWidth: "1.5"
  }));
}, {
  "replaceColor": true
});